import { render, staticRenderFns } from "./wish-operations.vue?vue&type=template&id=c34fa510&scoped=true&"
import script from "./wish-operations.vue?vue&type=script&lang=js&"
export * from "./wish-operations.vue?vue&type=script&lang=js&"
import style0 from "./wish-operations.vue?vue&type=style&index=0&id=c34fa510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34fa510",
  null
  
)

export default component.exports